import { render, staticRenderFns } from "./KPIGauge.vue?vue&type=template&id=3b24c9eb&scoped=true&"
import script from "./KPIGauge.vue?vue&type=script&lang=js&"
export * from "./KPIGauge.vue?vue&type=script&lang=js&"
import style0 from "./KPIGauge.vue?vue&type=style&index=0&id=3b24c9eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24c9eb",
  null
  
)

export default component.exports